import React, { useState, useEffect, useRef } from 'react'
import Column from '~/Common-Objects/Grids/Column/Column'
import Row from '~/Common-Objects/Grids/Row/Row'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import moment from 'moment'
import SettingTemplate from '../../shared/settingTemplate'

export default function Step3Advanced({ show = false, refresh = 0, toggled = 0, campaign, updateOptions, updateCampaign, saveCampaign, totalSubs = 0 }) {
    const [timeblocks, setTimeblocks] = useState([])
    const [showBatchSize, setShowBatchSize] = useState(campaign.batchSize > 0 && campaign.batchDelay > 0 && campaign.batchUnit)
    const [showResendAfter, setShowResendAfter] = useState(campaign.resendAfter > 0)
    const [showLimitSendingTimes, setShowLimitSendingTimes] = useState(campaign?.options?.betweenStart && campaign?.options?.betweenEnd)
    const [limitEnabled, setLimitEnabled] = useState(!!campaign?.limit)
    const scrollTo = useRef(null)

    const toggleSendingTimes = () => {
        if (showLimitSendingTimes) {
            campaign.options.betweenStart = null
            campaign.options.betweenEnd = null
            setShowLimitSendingTimes(false)
        } else {
            campaign.options.betweenStart = '09:00'
            campaign.options.betweenEnd = '17:00'
            setShowLimitSendingTimes(true)
        }
        updateCampaign()
    }

    const changeBatchSending = () => {
        if (showBatchSize) {
            campaign.batchSize = 0
            campaign.batchDelay = 0
            campaign.batchUnit = 'minutes'
            updateCampaign()
            saveCampaign()
        }
        setShowBatchSize(!showBatchSize)
    }

    const update = (e) => {
        const { name, value } = e.target
        campaign[name] = value
        console.log(name, value)
        updateCampaign()
    }

    useEffect(() => {
        if (toggled) {
            setTimeout(() => {
                if (scrollTo.current) {
                    scrollTo.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
            }, 100)
        }
    }, [toggled])

    useEffect(() => {
        if (refresh) {
            if (!campaign?.limit) {
                setLimitEnabled(false)
            }
            if (!campaign.options?.betweenStart && !campaign.options?.betweenEnd) {
                setShowLimitSendingTimes(false)
            }
            if (!campaign.batchSize && !campaign.batchDelay && !campaign.batchUnit) {
                setShowBatchSize(false)
            }
        }
    }, [refresh])

    useEffect(() => {
        const _timeblocks = []
        var time = moment('00:00', 'HH:mm')
        for (var i = 0; i < 48; i++) {
            let timeUtc = time.clone().utc()
            _timeblocks.push({ label: time.format('HH:mm'), value: timeUtc.format() })
            time.add(30, 'minutes')
        }
        setTimeblocks(_timeblocks)
    }, [])

    const hasBatchSending = campaign?.batchDelay > 0 && campaign?.batchSize > 0 && campaign?.batchUnit
    const timeBasedSending = campaign?.options?.timeBasedSending
    const threeWaveSending = campaign?.options?.threeWaveSending
    const importFromWebDetected = campaign.options.importFromWebUrl ? true : false
    const rssCampaign = campaign.dynamicRssFound
    let batchDisabled = '', limitSendingDisabled = '', resendAfterDisabled = '', limitDisabled = ''
    if (campaign?.options?.betweenEnd && campaign?.options?.betweenStart) {
        batchDisabled = 'Disabled because you have choosen to limit the send times'
    }
    if (timeBasedSending) {
        batchDisabled = 'Overriden by Best Engagement sending'
        limitSendingDisabled = 'Overriden by Best Engagement sending'
        limitDisabled = 'Overriden by Best Engagement sending'
    } else if (threeWaveSending) {
        batchDisabled = 'Overriden by Optimised Delivery sending'
        limitDisabled = 'Overriden by Optimised Delivery sending'
    }
    if (importFromWebDetected) {
        resendAfterDisabled = 'Disabled because you have chosen to import from web'
    }
    if (rssCampaign) {
        resendAfterDisabled = 'Disabled because you have chosen to use RSS'
    }

    let estimatedBatchTime
    let batchError = ''
    if (hasBatchSending && totalSubs) {
        let inMinutes = campaign.batchUnit === 'minutes' ? campaign.batchDelay : campaign.batchDelay * 60
        estimatedBatchTime = Math.ceil((totalSubs / campaign.batchSize) * inMinutes)
        // convert minutes to hours
        if (estimatedBatchTime > 60) {
            // show days if it's more than 24 hours
            if (estimatedBatchTime > 1440) {
                estimatedBatchTime = Math.ceil(estimatedBatchTime / 1440) + ' days'
            } else {
                estimatedBatchTime = Math.ceil(estimatedBatchTime / 60) + ' hours'
            }
        } else {
            estimatedBatchTime += ' minutes'
        }
        if (campaign.batchSize > 10000) {
            batchError = 'Batch size cannot exceed 10,000'
        }
    }

    return (
        <div style={{ display: show ? 'block' : 'none', marginTop: show ? 20 : 0 }}>
            {campaign.type !== 6 && <SettingTemplate
                header="Limit Sending Times"
                subheader={i18n.t('campaigns:standard.step3.sendingTimesDescription')}
                disabled={limitSendingDisabled}
                enabled={showLimitSendingTimes}
                setEnabled={toggleSendingTimes}
            >
                <div className="row">
                    <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                        <Select
                            label="Start Time"
                            data={timeblocks}
                            value={campaign.options.betweenStart}
                            name='betweenStart'
                            onChange={updateOptions}
                        />
                    </div>
                    <div className="col-xs-6 col-sm-6 col-md-3 col-lg-3">
                        <Select
                            label="End Time"
                            data={timeblocks}
                            value={campaign.options.betweenEnd}
                            name='betweenEnd'
                            onChange={updateOptions}
                        />
                    </div>
                </div>
            </SettingTemplate>}

            {campaign.type !== 6 && <SettingTemplate
                header="Auto Resend"
                subheader="Resend this campaign to recipients who haven’t opened it after a specified number of days"
                enabled={showResendAfter}
                disabled={resendAfterDisabled}
                setEnabled={() => {
                    if (showResendAfter) {
                        campaign.resendAfter = 0
                        setShowResendAfter(false)
                    } else {
                        setShowResendAfter(true)
                    }
                    updateCampaign()
                }}
            >
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-3 ">
                        <TextInput
                            type="number"
                            value={campaign.resendAfter}
                            name="resendAfter"
                            onChange={update}
                            label="Days before resend"
                            placeholder="0"
                            iconRight={<div style={{ color: 'var(--neutral-800)', cursor: 'default' }}>days</div>}
                        />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-9">
                        <TextInput
                            value={campaign.options?.resendSubject || campaign.subject}
                            name="resendSubject"
                            onChange={updateOptions}
                            label={<>Subject Line for resend <SquareChip className="mar-l5">Optional</SquareChip></>}
                            placeholder="Subject"
                        />
                    </div>
                </div>
            </SettingTemplate>}


            <SettingTemplate
                header={campaign.type === 6 ? "Send Limit" : "Email Limit"}
                subheader="Limit sending to a random number of recipients."
                enabled={limitEnabled}
                disabled={limitDisabled}
                setEnabled={() => {
                    if (limitEnabled) {
                        campaign.limit = 0
                        setLimitEnabled(false)
                    } else {
                        setLimitEnabled(true)
                    }
                    updateCampaign()
                }}
            >
                <div className="row">
                    <div className="col-xs-6 col-sm-4 col-md-3 col-sm-2">
                        <TextInput name="limit" value={campaign.limit} onChange={update} plcaeholder="0" type="number" label="Number of recipients to send" />
                    </div>
                </div>
            </SettingTemplate>

            <SettingTemplate
                header="Batch Sending"
                subheader="Useful to help manage website traffic. Sends will be dispersed across the defined time period."
                disabled={batchDisabled}
                enabled={showBatchSize}
                setEnabled={changeBatchSending}
                ref={scrollTo}
            >
                <Row>
                    <div className="col-xs-12 col-md-6 mar-b25">
                        <div className="txtInput_label">Batch Size</div>
                        <div className='mar-b5' style={{ color: 'gray', 'fontSize': 12 }} dangerouslySetInnerHTML={{ __html: 'The number of recipients in each batch ' }} />
                        <TextInput type="number" max={5000} min={0} value={campaign.batchSize} name="batchSize" onChange={update} placeholder={i18n.t('campaigns:main.setTo0ToSendFast')} />
                    </div>

                    <div className="col-xs-12 col-md-6 mar-b10">
                        <div className="txtInput_label">Time Period</div>
                        <div className='mar-b5' style={{ color: 'gray', 'fontSize': 12 }} dangerouslySetInnerHTML={{ __html: 'The time each batch of emails should be dispersed over ' }} />

                        <div className="row">
                            <div className="col-xs-12 col-md-6 mar-b25">
                                <TextInput type="number" value={campaign.batchDelay} name="batchDelay" min={0} onChange={update} />
                            </div>
                            <div className="col-xs-12 col-md-6 mar-b10">
                                <Select value={campaign.batchUnit} data={['minutes', 'hours']} name="batchUnit" min={0} onChange={update} />
                            </div>
                        </div>

                    </div>

                    <Column xs={12}>
                        {!batchError && <div className="quickFlex">
                            <div style={{ color: 'gray', marginRight: 8 }}>Estimated send duration: </div>
                            <div style={{ fontSize: 16, lineHeight: '24px' }}><strong>{estimatedBatchTime}</strong></div>
                        </div>}
                        {!!batchError && <div style={{ fontSize: 16, lineHeight: '24px' }} className="text-red"><strong>{batchError}</strong></div>}
                    </Column>

                </Row>
            </SettingTemplate>

        </div>
    )
}